import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProLocationModel } from '../typings/haynes-pro.location';
import { HaynesProService }       from '../haynes-pro.service';
import { HaynesProSubGroupModel } from '../typings/haynes-pro.sub-group';
import { MessagesService }        from '../../messages/messages.service';
import { VehicleModel }           from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-locations',
  template: require('./haynes-pro.diagnostic-tool.locations.component.html')
})
export class HaynesProDiagnosticToolLocationsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProLocationsBlock') block : NgBlockUI;

  @Input() subGroups: Array<HaynesProSubGroupModel>;
  @Input() isActive : boolean;
  @Input() vehicle  : VehicleModel;

  locations: Array<HaynesProLocationModel> = [];
  subGroup : HaynesProSubGroupModel;

  constructor (
    @Inject(forwardRef(() => HaynesProService)) private haynesProService : HaynesProService,
    private messagesService  : MessagesService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {

      this.subGroups[0].selected = true;

      };

    }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ) : void {
    this.block.start();

    this.locations = [];
    this.subGroup  = subGroup;

    this.haynesProService.getLocations(this.vehicle)
    .then(( locations : Array<HaynesProLocationModel> ) => {
      this.locations = locations;

      if ( !this.isActive ) {


        this.haynesProService.updateSubscriptionStatus(true);


      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}